//polyfill for TS to include as first import in the app main file.
window['__extends'] = function (d, b) {
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
